import { DocumentDownloadIcon } from '@heroicons/react/outline';
import React from 'react';
import { useDocumentAvailability } from '../hooks/useDocumentAvailability';

interface Props {
  certNumber: string | null | undefined;
  showIcon?: boolean;
}

const DocumentLink: React.FC<Props> = ({ certNumber, showIcon = false }) => {
  const { isAvailable, isLoading, documentUrl } =
    useDocumentAvailability(certNumber);

  if (!certNumber) {
    return <span>-</span>;
  }

  if (isLoading) {
    return <span className="text-gray-400">{certNumber}</span>;
  }

  if (!isAvailable || !documentUrl) {
    return <span>{certNumber}</span>;
  }

  return (
    <a
      href={documentUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="text-indigo-600 hover:text-indigo-900 hover:underline inline-flex items-center gap-1"
    >
      {certNumber}

      {showIcon && <DocumentDownloadIcon className="h-4 w-4" />}
    </a>
  );
};

export default DocumentLink;
